<template>
  <div  id="location-search-alert-modal" class="modal" style="display: block;"
       v-if="value">
    <div v-click-outside="close" class="modal-content"><span id="closeBttn" class="close" @click="close">×</span>
      <h2 class="modalTitle">Location Not Found</h2>
      <p>While we don't currently have a nearby <span class="map-site-title">{{ site_title }}</span> location that can service your area, we may still have a partner available to help.</p>
      <p>Feel free to contact us for more information!</p>
      <p>We're opening new locations and expanding our service areas all the time, so please check back again in the future!</p>
      <a class="blue-bttn" href="/contact/">Contact Us</a>
    </div>
  </div>
</template>

<script>
  import ClickOutside from "vue-click-outside";

  export default {

    name:       "CustomModal",
    props:      {
      value: Boolean,
    },
    computed: {
      site_title(){
        return googlemap_deps ? googlemap_deps.site_title: 'Belfor';
      }
    },
    methods:{
      close(){
        this.$emit('input', false)
      }
    },
    directives: {
      ClickOutside,
    },
  };
</script>

<style scoped>

</style>
